import { IScheduleInterval, DayOfWeek } from "../interfaces/intefaces";

export function isWithinPolicy(intervals: any[]) {
    const now = new Date();
    const dayNames = [DayOfWeek.SUNDAY, DayOfWeek.MONDAY, DayOfWeek.TUESDAY, DayOfWeek.WEDNESDAY, DayOfWeek.THURSDAY, DayOfWeek.FRIDAY, DayOfWeek.SATURDAY];
    const currentDay = dayNames[now.getDay()];

    if (!intervals || intervals.length === 0) {
        return false;
    }

    const todayIntervals = intervals.filter(interval => interval.dayOfWeek === currentDay);

    if (todayIntervals.length === 0) {
        return false;
    }

    const currentTimeMS = now.getHours() * 60 * 60 * 1000 + now.getMinutes() * 60 * 1000 + now.getSeconds() * 1000;

    for (const interval of todayIntervals) {
        const startTimeMS = timeToMilliseconds(interval.startTime);
        const endTimeMS = timeToMilliseconds(interval.endTime);

        if (startTimeMS <= endTimeMS) {
            if (currentTimeMS >= startTimeMS && currentTimeMS <= endTimeMS) {
                return true;
            }
        } else {
            if (currentTimeMS >= startTimeMS || currentTimeMS <= endTimeMS) {
                return true;
            }
        }
    }

    return false;
}


function timeToMilliseconds(time: string) {
    if (!time) return 0;
    
    if (time.includes("AM") || time.includes("PM")) {
        const [timePart, modifier] = time.split(" ");
        let [hours, minutes] = timePart.split(":").map(Number);

        if (modifier === "PM" && hours !== 12) {
            hours += 12;
        }
        if (modifier === "AM" && hours === 12) {
            hours = 0;
        }

        return (hours * 60 + minutes) * 60 * 1000;
    }
    
    const [hours, minutes] = time.split(":").map(Number);
    return (hours * 60 + minutes) * 60 * 1000;
}

export function formateDate(dataISO: string) {
    const data = new Date(dataISO);
    return data.toLocaleString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }).replace(",", " às");
}

export function formateDateDiaHora(dataISO: string) {
    const data = new Date(dataISO);
    const agora = new Date();

    const dataZero = new Date(data.getFullYear(), data.getMonth(), data.getDate());
    const agoraZero = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());

    const diffDias = Math.floor((agoraZero.getTime() - dataZero.getTime()) / (1000 * 60 * 60 * 24));

    const horaMinuto = data.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit"
    });

    if (diffDias === 0) {
        return `${horaMinuto} de hoje`;
    } else if (diffDias === 1) {
        return `${horaMinuto} de ontem`;
    } else {
        return `${horaMinuto} de ` + data.toLocaleDateString("pt-BR");
    }
}

export function convertTime(timestamp: any) {
    const date = new Date(timestamp * 1000);
    const options: Intl.DateTimeFormatOptions  = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    };
    return date.toLocaleString('pt-BR', options);
}
